import { Typography, styled } from "@mui/material";

export const SubTitle = styled(Typography)<any>(({ theme, variant }) => ({
  fontSize: theme.breakpoints.down("md") ? "14px" : "16px",
  fontWeight: 400,
  lineHeight: theme.breakpoints.down("md") ? "20px" : "24px",
  color: "#A2A2A2",
}));

export const Title = styled(Typography)<any>(({ theme, variant }) => ({
  fontSize: theme.breakpoints.down("md") ? "15px" : "18px",
  fontWeight: 600,
  lineHeight: theme.breakpoints.down("md") ? "22px" : "26px",
  color: "#323232",
}));
